import { Container, Header } from "components/Page"

import Breadcrumbs from "components/Breadcrumbs"
import { Surface } from "components/Surface"
import { useI18n } from "providers/I18n"
import { TargetDetails } from "./TargetDetails"

function MarketTargets() {
  const { t } = useI18n()

  return (
    <Container>
      <Breadcrumbs section={t("nav.admin")} current={t("nav.market.targets")} />
      <Header label={t("nav.market.targets")}></Header>
      <Surface>
        <TargetDetails />
      </Surface>
    </Container>
  )
}

export default MarketTargets
